/** @format */

import React, { Component } from 'react';
import {
  Segment,
  Icon,
  Header,
  Divider,
  Grid,
  Table,
  Popup,
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { requestProgresses } from '../../../../../../../constants';
import OptionAvailableButtons from './OptionAvailableButtons/OptionAvailableButtons';
import OptionSoldButtons from './OptionSoldButtons/OptionSoldButtons';
import './RequestPartOption.css';

@inject('UserStore', 'RequestsStore')
@observer
class RequestPartOption extends Component {
  renderContent = content => {
    if (content !== undefined && content !== null && content !== '') {
      return content;
    } else {
      return '-';
    }
  };

  getOptionBoxClasses = () => {
    const { RequestsStore, partId, optionKey } = this.props;
    const currentOption =
      RequestsStore.currentRequest.reqParts[partId].options[optionKey];
    let optionBoxClasses = null;
    if (currentOption && currentOption.data && currentOption.data.checked === 'unchecked') {
      optionBoxClasses = 'option-box unchecked';
    }
    if (currentOption && currentOption.data && currentOption.data.checked === true) {
      optionBoxClasses = 'option-box checkedTrue';
    }
    if (currentOption && currentOption.data && currentOption.data.checked === false) {
      optionBoxClasses = 'option-box checkedFalse';
    }
    return optionBoxClasses;
  };

  renderAvailableIcon = () => {
    const { RequestsStore, partId, optionKey } = this.props;
    const currentOption =
      RequestsStore.currentRequest.reqParts[partId].options[optionKey];
    let availableIcon = null;
    if (currentOption && currentOption.data && currentOption.data.checked === 'unchecked') {
      availableIcon = <Icon name="exclamation circle" color="orange" />;
    }
    if (currentOption && currentOption.data && currentOption.data.checked === true) {
      availableIcon = <Icon name="check circle" color="green" />;
    }
    if (currentOption && currentOption.data && currentOption.data.checked === false) {
      availableIcon = <Icon name="remove circle" color="red" />;
    }
    return availableIcon;
  };

  renderCheckOptionButtons = () => {
    const { RequestsStore, UserStore, partId, optionKey } = this.props;
    const requestProgress = RequestsStore.currentRequest.data.progress;

    if (UserStore.user !== null) {
      if (
        UserStore.isWarehouse ||
        UserStore.user.role === 'admin' ||
        (UserStore.isSeller &&
          RequestsStore.currentRequest.data.autoManagement &&
          requestProgress !== requestProgresses.BARGAINING_SALE)
      ) {
        return (
          <OptionAvailableButtons
            partId={partId}
            optionKey={optionKey}
            checked={
              RequestsStore.currentRequest.reqParts[partId].options[optionKey] &&
              RequestsStore.currentRequest.reqParts[partId].options[optionKey].data && RequestsStore.currentRequest.reqParts[partId].options[optionKey].data.checked
            }
          />
        );
      }
    }
  };

  renderSoldOptionButtons = () => {
    const { RequestsStore, UserStore, partId, optionKey } = this.props;
    const currentOption =
      RequestsStore.currentRequest.reqParts[partId].options[optionKey];

    let reqPartsChecked = RequestsStore.currentRequest.data.reqPartsChecked;
    let reqPartsNum = RequestsStore.currentRequest.data.reqPartsNum;
    let requestProgress = RequestsStore.currentRequest.data.progress;
    let optionChecked = currentOption && currentOption.data && currentOption.data.checked;
    let isActive = RequestsStore.isActive;

    if (UserStore.user !== null) {
      if (
        (UserStore.user.role === 'seller' &&
          reqPartsChecked === reqPartsNum &&
          requestProgress === requestProgresses.BARGAINING_SALE &&
          optionChecked &&
          isActive) ||
        (UserStore.user.role === 'admin' &&
          reqPartsChecked === reqPartsNum &&
          requestProgress === requestProgresses.BARGAINING_SALE &&
          optionChecked &&
          isActive)
      ) {
        return <OptionSoldButtons partId={partId} optionKey={optionKey} />;
      }
    }
  };

  renderRemoveOptionButton = () => {
    const { RequestsStore, partId, optionKey } = this.props;
    const currentRequestId = RequestsStore.requestsParams.currentRequestId;
    if (
      currentRequestId !== undefined &&
      currentRequestId !== null &&
      currentRequestId !== ''
    ) {
      return null;
    } else {
      return (
        <Popup
          trigger={
            <Icon
              className="clickable"
              name="trash"
              color="red"
              onClick={() =>
                RequestsStore.handleReqOptionRemove(
                  partId,
                  optionKey,
                  currentRequestId,
                )
              }
            />
          }
          content="Elimina Opzione"
        />
      );
    }
  };

  render() {
    const { RequestsStore, partId, optionKey } = this.props;
    const currentOption =
      RequestsStore.currentRequest.reqParts[partId].options[optionKey];
    return (
      <Segment key={optionKey} className={this.getOptionBoxClasses()}>
        <Grid>
          <Grid.Row className="reqPart-head">
            <Grid.Column computer="13">
              <Header as="h4">
                {this.renderAvailableIcon()} Opzione {Number(optionKey) + 1} -{' '}
                {Number(currentOption && currentOption.data &&currentOption.data.price).toFixed(2)}€ (Aggiunta da{' '}
                {currentOption && currentOption.data && currentOption.data.addedBy}- {currentOption && currentOption.data && currentOption.data.addedByRole})
              </Header>
            </Grid.Column>
            <Grid.Column
              className="action-icons"
              computer="3"
              textAlign="right"
            >
              {this.renderRemoveOptionButton()}&nbsp;&nbsp;&nbsp;
              <Popup
                trigger={
                  <Icon
                    className="clickable"
                    name="pencil"
                    onClick={() => {
                      RequestsStore.toggleOptionForm(partId, false);
                      RequestsStore.loadCurrentOption(partId, optionKey);
                    }}
                  />
                }
                content="Modifica opzione"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider />
        <Table compact basic="very" fixed>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <small>
                  <strong>Condizioni</strong>
                </small>
                <br />
                {this.renderContent(currentOption && currentOption.data && currentOption.data.conditions)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Colore</strong>
                </small>
                <br />
                {this.renderContent(currentOption && currentOption.data && currentOption.data.color)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>Posizione Scaffale</strong>
                </small>
                <br />
                {this.renderContent(currentOption && currentOption.data && currentOption.data.position)}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <small>
                  <strong>Codice Interno</strong>
                </small>
                <br />
                {this.renderContent(currentOption && currentOption.data &&currentOption.data.internalCode)}
              </Table.Cell>
              <Table.Cell colSpan={2}>
                <small>
                  <strong>Note</strong>
                </small>
                <br />
                {this.renderContent(currentOption && currentOption.data && currentOption.data.notes)}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        {this.renderCheckOptionButtons()}
        {this.renderSoldOptionButtons()}
      </Segment>
    );
  }
}

export default RequestPartOption;
